import { useState } from 'react';
import type { ActiveModal } from '../types/domain';

export function useModal() {
  const [activeModal, setActiveModal] = useState<ActiveModal | null>(null);
  const [errorMessage, setErrorMessage] = useState('');

  const openError = (message: string) => {
    setErrorMessage(message);
    setActiveModal('error');
  };

  const openPaymentError = (message: string) => {
    setErrorMessage(message);
    setActiveModal('paymentError');
  };

  const close = () => {
    setActiveModal(null);
    setErrorMessage('');
  };

  return {
    activeModal,
    setActiveModal,
    errorMessage,
    openError,
    openPaymentError,
    close,
  };
}
